import 'odisseia/src/components/overlay.css.ts.vanilla.css?source=Ll84Yjh1M2EwIHsKICBwb3NpdGlvbjogZml4ZWQ7CiAgaW5zZXQ6IDA7CiAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7CiAgei1pbmRleDogMTA7Cn0=';
export var overlayStyle = '_8b8u3a0';